/**
 * Tailwind breakpoints
 * These match the default Tailwind CSS breakpoints
 */
export const tailwindBreakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
} as const

export type BreakpointKey = keyof typeof tailwindBreakpoints

